<template>
  <div :class="elementClass">
    <div class="--overlay" @click="click"></div>
    <div class="--element">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { overlayClass } from "../prefix";
export default {
  props: {
    value: {
      default: false,
      type: Boolean,
    },
    inverse: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    elementClass() {
      return [overlayClass, this.value ? " active" : "", this.inverse ? " inverse" : ""];
    },
  },
  methods: {
    click(e) {
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-overlay";

#{$element} {
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 50;
  top: 0;
  left: 0;
  visibility: hidden;
  opacity: 0;
  @include transition(all 0.25s $animation-deceleration-curve-timing-function);

  .--overlay {
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    background: $color-black;
    opacity: 0;
    visibility: hidden;
    @include transition(all 0.25s $animation-deceleration-curve-timing-function);
  }
  .--element {
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    @include transition(all 0.25s $animation-deceleration-curve-timing-function);

    .os-content {
      visibility: hidden;
    }
  }

  &.active {
    visibility: visible;
    opacity: 1;
    z-index: 99;
    .--overlay {
      visibility: visible;
      opacity: 0.3;
    }

    .--element {
      visibility: hidden;

      & > *,
      .os-content {
        visibility: visible;
      }
    }
  }

  &.inverse {
    .--overlay {
      background: $color-white;
      opacity: 0.6;
    }
  }
}
</style>
